<template>
  <body>

    <Header></Header>
    <img src="ranking_logo.png" class="logo" height="50px" width="50px" />
    <span class="title">Ranking Variation</span>
    <div class="Intro">
      <div class="Intro-title">Bar Chart Race</div>
      <div class="Intro-explain">
        It is a useful way to display time series in a bar chart format via
        animation, and it can also show the ranking variation over time. Bar
        chart tells a compelling story which displays the data in a unique,
        interesting and understandable format, lending themselves to comments or
        questions from viewers who may spot different points of interest within
        the race.
      </div>
    </div>

    <div class="Intro2">
      <div class="Intro-title">
        Ranking Variation Of Countries
      </div>
      <div class="Intro-explain">
        In this bar chart race, we want to show the ranking variation of different countries over years on Netflix
        produced content, the number value of each country is the sum count of
        Movies and TVs Netflix produced over years.
      </div>
    </div>

    <div class="race">
      <div class="race_title">
        Top 12 Ranking Variation of Countries over years
      </div>
      <b-button variant="dark" @click="bar_chart_race" class="button"
        >play(fast)</b-button
      >
      <b-button variant="dark" @click="bar_chart_slow" class="button2"
        >play(slow)</b-button
      >
      <b-button variant="dark" @click="first_draw" class="button3"
        >stop</b-button
      >
      <div class="race_chart">
        <svg id="chart" width="900" height="500"></svg>
      </div>
    </div>

    <router-link to="/sunburst" @click.native="scrollToTop">
      <div class="next">
        <img src="next.png" height="50px" width="50px" />
      </div>
    </router-link>
  </body>
</template>

<script>
import * as d3 from "d3";
import Header from "@/components/Header";
export default {
  name: "bar_chart_race",
  components: {
    Header,
  },
  data: function () {
    return {
      bar_chart_race_data: null,
    };
  },

  methods: {
    /* eslint-disable */
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    bar_chart_race() {
      var data = this.bar_chart_race_data;
      var margin = { top: 60, right: 125, bottom: 6, left: 0 };
      var height = margin.top + barSize * n + margin.bottom;
      var barSize = 40;
      var n = 12;
      var duration = 20;

      d3.select("svg").remove();
      const svg = d3
        .select(".race_chart")
        .append("svg")
        .attr("width", "900")
        .attr("height", "570");
      var width = svg.attr("width");
      //svg.attr("viewBox", [0, 0, width, height]);

      var scale = d3
        .scaleOrdinal()
        .domain(["Asia", "Europe", "Africa", "Oceania", "Americas"])
        .range(['#29c7ac','#a7d129','#e94560','#fcdab7','#bc6ff1'])

      //draw legend
      var domain = ["Asia", "Europe", "Africa", "Oceania", "Americas"];
      for (var i in domain) {
        svg
          .append("rect")
          .attr("x", 0 + i * 130)
          .attr("y", 0)
          .attr("width", "40px")
          .attr("height", "15px")
          .attr("fill", scale(domain[i]))
          .attr("fill-opacity", 0.6);

        svg
          .append("text")
          .attr("x", 45 + i * 130)
          .attr("y", 13)
          .attr("fill", "rgba(255, 255, 255, 0.815)")
          .text(domain[i]);
      }

      //console.log(d3.group(data,d=>d.name))
      //console.log(data.filter(d=>d.name==="Heineken"))
      var formatDate = d3.utcFormat("%Y");
      var names = new Set(data.map((d) => d.name));

      var datevalues = Array.from(
        d3.rollup(
          data,
          ([d]) => d.value,
          (d) => d.date,
          (d) => d.name
        )
      )
        .map(([date, data]) => [new Date(date), data])
        .sort(([a], [b]) => d3.ascending(a, b));

      //console.log(Array.from(d3.rollup(data, ([d]) => d => d.name, d => d.date,d=>d.value)))
      //console.log(d3.rollup(data,([v])=>v.date,d=>d.name))
      function rank(value) {
        const data = Array.from(names, (name) => ({
          name,
          value: value(name),
        }));
        data.sort((a, b) => d3.descending(a.value, b.value));
        for (let i = 0; i < data.length; ++i) data[i].rank = Math.min(n, i);
        return data;
      }

      var k = 10;

      //keyframes
      var keyframes = [];
      let ka, a, kb, b;

      for ([[ka, a], [kb, b]] of d3.pairs(datevalues)) {
        for (let i = 0; i < k; ++i) {
          const t = i / k;
          keyframes.push([
            new Date(ka * (1 - t) + kb * t),
            rank(
              (name) => (a.get(name) || 0) * (1 - t) + (b.get(name) || 0) * t
            ),
          ]);
        }
      }
      keyframes.push([new Date(kb), rank((name) => b.get(name) || 0)]);

      var nameframes = d3.groups(
        keyframes.flatMap(([, data]) => data),
        (d) => d.name
      );
      var prev = new Map(
        nameframes.flatMap(([, data]) => d3.pairs(data, (a, b) => [b, a]))
      );
      var next = new Map(nameframes.flatMap(([, data]) => d3.pairs(data)));
      for (var i in nameframes) {
        for (var d in data) {
          if (nameframes[i][0] == data[d].name) {
            for (var p in nameframes[i][1]) {
              nameframes[i][1][p]["continent"] = data[d].continent;
            }
          }
        }
      }

      //bars
      function bars(svg) {
        let bar = svg.append("g").attr("fill-opacity", 0.6).selectAll("rect");

        return ([date, data], transition) =>
          (bar = bar
            .data(data.slice(0, n), (d) => d.name)
            .join(
              (enter) =>
                enter
                  .append("rect")
                  .attr("fill", (d) => scale(d.continent))
                  .attr("height", y.bandwidth())
                  .attr("x", x(0))
                  .attr("y", (d) => y((prev.get(d) || d).rank))
                  .attr("width", (d) => x((prev.get(d) || d).value) - x(0)),
              (update) => update,
              (exit) =>
                exit
                  .transition(transition)
                  .remove()
                  .attr("y", (d) => y((next.get(d) || d).rank))
                  .attr("width", (d) => x((next.get(d) || d).value) - x(0))
            )
            .call((bar) =>
              bar
                .transition(transition)
                .attr("y", (d) => y(d.rank))
                .attr("width", (d) => x(d.value) - x(0))
            ));
      }

      //labels
      function labels(svg) {
        let label = svg
          .append("g")
          //.style("font", "bold 8px var(--sans-serif)")
          .attr("font-size", "14px")
          .style("fill", "rgba(255, 255, 255, 0.815)")
          .style("font-variant-numeric", "tabular-nums")
          .attr("text-anchor", "end")
          .selectAll("text");

        return ([date, data], transition) =>
          (label = label
            .data(data.slice(0, n), (d) => d.name)
            .join(
              (enter) =>
                enter
                  .append("text")
                  .attr(
                    "transform",
                    (d) =>
                      `translate(${x((prev.get(d) || d).value)},${y(
                        (prev.get(d) || d).rank
                      )})`
                  )
                  .attr("y", y.bandwidth() / 2)
                  .attr("x", -6 + 125)
                  .attr("dy", "-0.25em")
                  .text((d) => d.name)
                  .call((text) =>
                    text
                      .append("tspan")
                      .attr("fill-opacity", 0.7)
                      .attr("font-weight", "normal")
                      .attr("x", -6 + 125)
                      .attr("dy", "1.15em")
                  ),
              (update) => update,
              (exit) =>
                exit
                  .transition(transition)
                  .remove()
                  .attr(
                    "transform",
                    (d) =>
                      `translate(${x((next.get(d) || d).value)},${y(
                        (next.get(d) || d).rank
                      )})`
                  )
                  .call((g) =>
                    g
                      .select("tspan")
                      .tween("text", (d) =>
                        textTween(d.value, (next.get(d) || d).value)
                      )
                  )
            )
            .call((bar) =>
              bar
                .transition(transition)
                .attr(
                  "transform",
                  (d) => `translate(${x(d.value)},${y(d.rank)})`
                )
                .call((g) =>
                  g
                    .select("tspan")
                    .tween("text", (d) =>
                      textTween((prev.get(d) || d).value, d.value)
                    )
                )
            ));
      }

      //texttween
      function textTween(a, b) {
        const i = d3.interpolateNumber(a, b);
        return function (t) {
          this.textContent = formatNumber(i(t));
        };
      }

      var formatNumber = d3.format(",d");

      //axis
      function axis(svg) {
        const g = svg
          .append("g")
          .attr("transform", `translate(0,${margin.top})`);

        const axis = d3
          .axisTop(x)
          .ticks(width / 160)
          .tickSizeOuter(0)
          .tickSizeInner(-barSize * (n + y.padding()));

        return (_, transition) => {
          g.transition(transition).call(axis);
          g.select(".tick:first-of-type text").remove();
          g.selectAll("text").attr("stroke", "rgba(255, 255, 255, 0.515)");
          g.selectAll(".tick:not(:first-of-type) line").attr(
            "stroke",
            "rgba(255, 255, 255, 0.15)"
          );
          g.select(".domain").remove();
        };
      }

      //ticker
      function ticker(svg) {
        const now = svg
          .append("text")
          //.style("font", `bold ${barSize}px var(--sans-serif)`)
          .style("font-variant-numeric", "tabular-nums")
          .attr("text-anchor", "end")
          .attr("font-size", 30)
          .attr("fill", "rgba(255, 255, 255, 0.815)")
          .attr("x", width - 6)
          .attr("y", margin.top + barSize * (n - 0.45))
          .attr("dy", "0.32em")
          .text(formatDate(keyframes[0][0]));

        return ([date], transition) => {
          transition.end().then(() => now.text(formatDate(date)));
        };
      }

      //color scale
      // function color() {
      //   const scale = d3.scaleOrdinal(d3.schemeTableau10);
      //   if (data.some((d) => d.category !== undefined)) {
      //     const categoryByName = new Map(data.map((d) => [d.name, d.category]));
      //     scale.domain(Array.from(categoryByName.values()));
      //     return (d) => scale(categoryByName.get(d.name));
      //   }
      //   return (d) => scale(d.name);
      // }

      //position
      var x = d3.scaleLinear([0, 1], [margin.left, width - margin.right]);
      var y = d3
        .scaleBand()
        .domain(d3.range(n + 1))
        .rangeRound([margin.top, margin.top + barSize * (n + 1 + 0.1)])
        .padding(0.1);

      const updateBars = bars(svg);
      const updateAxis = axis(svg);
      const updateLabels = labels(svg);
      const updateTicker = ticker(svg);

      async function draw() {
        for (const keyframe of keyframes) {
          const transition = svg
            .transition()
            .duration(duration)
            .ease(d3.easeLinear);

          // Extract the top bar’s value.
          x.domain([0, keyframe[1][0].value]);

          updateAxis(keyframe, transition);
          updateBars(keyframe, transition);
          updateLabels(keyframe, transition);
          updateTicker(keyframe, transition);

          // invalidation.then(() => svg.interrupt());
          await transition.end();
        }
      }

      draw();
    },
    first_draw() {
      var data = this.bar_chart_race_data;
      var margin = { top: 60, right: 125, bottom: 6, left: 0 };
      var height = margin.top + barSize * n + margin.bottom;
      var barSize = 40;
      var n = 12;
      var duration = 20;

      d3.select("svg").remove();
      const svg = d3
        .select(".race_chart")
        .append("svg")
        .attr("width", "900")
        .attr("height", "570");
      var width = svg.attr("width");
      //svg.attr("viewBox", [0, 0, width, height]);

      var scale = d3
        .scaleOrdinal()
        .domain(["Asia", "Europe", "Africa", "Oceania", "Americas"])
        // .range(["#E94560", "#F2A365", "#3282B8", "#C02739", "#a32f80"]);
        .range(['#29c7ac','#a7d129','#e94560','#fcdab7','#bc6ff1'])

      //draw legend
      var domain = ["Asia", "Europe", "Africa", "Oceania", "Americas"];
      for (var i in domain) {
        svg
          .append("rect")
          .attr("x", 0 + i * 130)
          .attr("y", 0)
          .attr("width", "40px")
          .attr("height", "15px")
          .attr("fill", scale(domain[i]))
          .attr("fill-opacity", 0.6);

        svg
          .append("text")
          .attr("x", 45 + i * 130)
          .attr("y", 13)
          .attr("fill", "rgba(255, 255, 255, 0.815)")
          .text(domain[i]);
      }

      //console.log(d3.group(data,d=>d.name))
      //console.log(data.filter(d=>d.name==="Heineken"))
      var formatDate = d3.utcFormat("%Y");
      var names = new Set(data.map((d) => d.name));

      var datevalues = Array.from(
        d3.rollup(
          data,
          ([d]) => d.value,
          (d) => d.date,
          (d) => d.name
        )
      )
        .map(([date, data]) => [new Date(date), data])
        .sort(([a], [b]) => d3.ascending(a, b));

      //console.log(Array.from(d3.rollup(data, ([d]) => d => d.name, d => d.date,d=>d.value)))
      //console.log(d3.rollup(data,([v])=>v.date,d=>d.name))
      function rank(value) {
        const data = Array.from(names, (name) => ({
          name,
          value: value(name),
        }));
        data.sort((a, b) => d3.descending(a.value, b.value));
        for (let i = 0; i < data.length; ++i) data[i].rank = Math.min(n, i);
        return data;
      }

      var k = 10;

      //keyframes
      const keyframes = [];
      let ka, a, kb, b;

      for ([[ka, a], [kb, b]] of d3.pairs(datevalues)) {
        for (let i = 0; i < k; ++i) {
          const t = i / k;
          keyframes.push([
            new Date(ka * (1 - t) + kb * t),
            rank(
              (name) => (a.get(name) || 0) * (1 - t) + (b.get(name) || 0) * t
            ),
          ]);
        }
      }
      keyframes.push([new Date(kb), rank((name) => b.get(name) || 0)]);

      var nameframes = d3.groups(
        keyframes.flatMap(([, data]) => data),
        (d) => d.name
      );
      var prev = new Map(
        nameframes.flatMap(([, data]) => d3.pairs(data, (a, b) => [b, a]))
      );
      var next = new Map(nameframes.flatMap(([, data]) => d3.pairs(data)));
      for (var i in nameframes) {
        for (var d in data) {
          if (nameframes[i][0] == data[d].name) {
            for (var p in nameframes[i][1]) {
              nameframes[i][1][p]["continent"] = data[d].continent;
            }
          }
        }
      }

      //bars
      function bars(svg) {
        let bar = svg.append("g").attr("fill-opacity", 0.6).selectAll("rect");

        return ([date, data], transition) =>
          (bar = bar
            .data(data.slice(0, n), (d) => d.name)
            .join(
              (enter) =>
                enter
                  .append("rect")
                  .attr("fill", (d) => scale(d.continent))
                  .attr("height", y.bandwidth())
                  .attr("x", x(0))
                  .attr("y", (d) => y((prev.get(d) || d).rank))
                  .attr("width", (d) => x((prev.get(d) || d).value) - x(0)),
              (update) => update,
              (exit) =>
                exit
                  .transition(transition)
                  .remove()
                  .attr("y", (d) => y((next.get(d) || d).rank))
                  .attr("width", (d) => x((next.get(d) || d).value) - x(0))
            )
            .call((bar) =>
              bar
                .transition(transition)
                .attr("y", (d) => y(d.rank))
                .attr("width", (d) => x(d.value) - x(0))
            ));
      }

      //labels
      function labels(svg) {
        let label = svg
          .append("g")
          //.style("font", "bold 8px var(--sans-serif)")
          .attr("font-size", "14px")
          .style("fill", "rgba(255, 255, 255, 0.815)")
          .style("font-variant-numeric", "tabular-nums")
          .attr("text-anchor", "end")
          .selectAll("text");

        return ([date, data], transition) =>
          (label = label
            .data(data.slice(0, n), (d) => d.name)
            .join(
              (enter) =>
                enter
                  .append("text")
                  .attr(
                    "transform",
                    (d) =>
                      `translate(${x((prev.get(d) || d).value)},${y(
                        (prev.get(d) || d).rank
                      )})`
                  )
                  .attr("y", y.bandwidth() / 2)
                  .attr("x", -6 + 125)
                  .attr("dy", "-0.25em")
                  .text((d) => d.name)
                  .call((text) =>
                    text
                      .append("tspan")
                      .attr("fill-opacity", 0.7)
                      .attr("font-weight", "normal")
                      .attr("x", -6 + 125)
                      .attr("dy", "1.15em")
                  ),
              (update) => update,
              (exit) =>
                exit
                  .transition(transition)
                  .remove()
                  .attr(
                    "transform",
                    (d) =>
                      `translate(${x((next.get(d) || d).value)},${y(
                        (next.get(d) || d).rank
                      )})`
                  )
                  .call((g) =>
                    g
                      .select("tspan")
                      .tween("text", (d) =>
                        textTween(d.value, (next.get(d) || d).value)
                      )
                  )
            )
            .call((bar) =>
              bar
                .transition(transition)
                .attr(
                  "transform",
                  (d) => `translate(${x(d.value)},${y(d.rank)})`
                )
                .call((g) =>
                  g
                    .select("tspan")
                    .tween("text", (d) =>
                      textTween((prev.get(d) || d).value, d.value)
                    )
                )
            ));
      }

      //texttween
      function textTween(a, b) {
        const i = d3.interpolateNumber(a, b);
        return function (t) {
          this.textContent = formatNumber(i(t));
        };
      }

      var formatNumber = d3.format(",d");

      //axis
      function axis(svg) {
        const g = svg
          .append("g")
          .attr("transform", `translate(0,${margin.top})`);

        const axis = d3
          .axisTop(x)
          .ticks(width / 160)
          .tickSizeOuter(0)
          .tickSizeInner(-barSize * (n + y.padding()));

        return (_, transition) => {
          g.transition(transition).call(axis);
          g.select(".tick:first-of-type text").remove();
          g.selectAll("text").attr("stroke", "rgba(255, 255, 255, 0.515)");
          g.selectAll(".tick:not(:first-of-type) line").attr(
            "stroke",
            "rgba(255, 255, 255, 0.15)"
          );
          g.select(".domain").remove();
        };
      }

      //ticker
      function ticker(svg) {
        const now = svg
          .append("text")
          //.style("font", `bold ${barSize}px var(--sans-serif)`)
          .style("font-variant-numeric", "tabular-nums")
          .attr("text-anchor", "end")
          .attr("font-size", 30)
          .attr("fill", "rgba(255, 255, 255, 0.815)")
          .attr("x", width - 6)
          .attr("y", margin.top + barSize * (n - 0.45))
          .attr("dy", "0.32em")
          .text(formatDate(keyframes[0][0]));

        return ([date], transition) => {
          transition.end().then(() => now.text(formatDate(date)));
        };
      }

      //color scale
      // function color() {
      //   const scale = d3.scaleOrdinal(d3.schemeTableau10);
      //   if (data.some((d) => d.category !== undefined)) {
      //     const categoryByName = new Map(data.map((d) => [d.name, d.category]));
      //     scale.domain(Array.from(categoryByName.values()));
      //     return (d) => scale(categoryByName.get(d.name));
      //   }
      //   return (d) => scale(d.name);
      // }

      //position
      var x = d3.scaleLinear([0, 1], [margin.left, width - margin.right]);
      var y = d3
        .scaleBand()
        .domain(d3.range(n + 1))
        .rangeRound([margin.top, margin.top + barSize * (n + 1 + 0.1)])
        .padding(0.1);

      const updateBars = bars(svg);
      const updateAxis = axis(svg);
      const updateLabels = labels(svg);
      const updateTicker = ticker(svg);

      async function draw() {
        for (const [i, keyframe] of keyframes.entries()) {
          if (i == 700) {
            const transition = svg
              .transition()
              .duration(duration)
              .ease(d3.easeLinear);

            // Extract the top bar’s value.
            x.domain([0, keyframe[1][0].value]);

            updateAxis(keyframe, transition);
            updateBars(keyframe, transition);
            updateLabels(keyframe, transition);
            updateTicker(keyframe, transition);

            // invalidation.then(() => svg.interrupt());
            await transition.end();
          }
        }
      }

      draw();
    },
    bar_chart_slow() {
      var data = this.bar_chart_race_data;
      var margin = { top: 60, right: 125, bottom: 6, left: 0 };
      var height = margin.top + barSize * n + margin.bottom;
      var barSize = 40;
      var n = 12;
      var duration = 200;

      d3.select("svg").remove();
      const svg = d3
        .select(".race_chart")
        .append("svg")
        .attr("width", "900")
        .attr("height", "570");
      var width = svg.attr("width");
      //svg.attr("viewBox", [0, 0, width, height]);

      var scale = d3
        .scaleOrdinal()
        .domain(["Asia", "Europe", "Africa", "Oceania", "Americas"])
        .range(['#29c7ac','#a7d129','#e94560','#fcdab7','#bc6ff1'])

      //draw legend
      var domain = ["Asia", "Europe", "Africa", "Oceania", "Americas"];
      for (var i in domain) {
        svg
          .append("rect")
          .attr("x", 0 + i * 130)
          .attr("y", 0)
          .attr("width", "40px")
          .attr("height", "15px")
          .attr("fill", scale(domain[i]))
          .attr("fill-opacity", 0.6);

        svg
          .append("text")
          .attr("x", 45 + i * 130)
          .attr("y", 13)
          .attr("fill", "rgba(255, 255, 255, 0.815)")
          .text(domain[i]);
      }

      //console.log(d3.group(data,d=>d.name))
      //console.log(data.filter(d=>d.name==="Heineken"))
      var formatDate = d3.utcFormat("%Y");
      var names = new Set(data.map((d) => d.name));

      var datevalues = Array.from(
        d3.rollup(
          data,
          ([d]) => d.value,
          (d) => d.date,
          (d) => d.name
        )
      )
        .map(([date, data]) => [new Date(date), data])
        .sort(([a], [b]) => d3.ascending(a, b));

      //console.log(Array.from(d3.rollup(data, ([d]) => d => d.name, d => d.date,d=>d.value)))
      //console.log(d3.rollup(data,([v])=>v.date,d=>d.name))
      function rank(value) {
        const data = Array.from(names, (name) => ({
          name,
          value: value(name),
        }));
        data.sort((a, b) => d3.descending(a.value, b.value));
        for (let i = 0; i < data.length; ++i) data[i].rank = Math.min(n, i);
        return data;
      }

      var k = 10;

      //keyframes
      var keyframes = [];
      let ka, a, kb, b;

      for ([[ka, a], [kb, b]] of d3.pairs(datevalues)) {
        for (let i = 0; i < k; ++i) {
          const t = i / k;
          keyframes.push([
            new Date(ka * (1 - t) + kb * t),
            rank(
              (name) => (a.get(name) || 0) * (1 - t) + (b.get(name) || 0) * t
            ),
          ]);
        }
      }
      keyframes.push([new Date(kb), rank((name) => b.get(name) || 0)]);

      var nameframes = d3.groups(
        keyframes.flatMap(([, data]) => data),
        (d) => d.name
      );
      var prev = new Map(
        nameframes.flatMap(([, data]) => d3.pairs(data, (a, b) => [b, a]))
      );
      var next = new Map(nameframes.flatMap(([, data]) => d3.pairs(data)));
      for (var i in nameframes) {
        for (var d in data) {
          if (nameframes[i][0] == data[d].name) {
            for (var p in nameframes[i][1]) {
              nameframes[i][1][p]["continent"] = data[d].continent;
            }
          }
        }
      }
      

      //bars
      function bars(svg) {
        let bar = svg.append("g").attr("fill-opacity", 0.6).selectAll("rect");

        return ([date, data], transition) =>
          (bar = bar
            .data(data.slice(0, n), (d) => d.name)
            .join(
              (enter) =>
                enter
                  .append("rect")
                  .attr("fill", (d) => scale(d.continent))
                  .attr("height", y.bandwidth())
                  .attr("x", x(0))
                  .attr("y", (d) => y((prev.get(d) || d).rank))
                  .attr("width", (d) => x((prev.get(d) || d).value) - x(0)),
              (update) => update,
              (exit) =>
                exit
                  .transition(transition)
                  .remove()
                  .attr("y", (d) => y((next.get(d) || d).rank))
                  .attr("width", (d) => x((next.get(d) || d).value) - x(0))
            )
            .call((bar) =>
              bar
                .transition(transition)
                .attr("y", (d) => y(d.rank))
                .attr("width", (d) => x(d.value) - x(0))
            ));
      }

      //labels
      function labels(svg) {
        let label = svg
          .append("g")
          //.style("font", "bold 8px var(--sans-serif)")
          .attr("font-size", "14px")
          .style("fill", "rgba(255, 255, 255, 0.815)")
          .style("font-variant-numeric", "tabular-nums")
          .attr("text-anchor", "end")
          .selectAll("text");

        return ([date, data], transition) =>
          (label = label
            .data(data.slice(0, n), (d) => d.name)
            .join(
              (enter) =>
                enter
                  .append("text")
                  .attr(
                    "transform",
                    (d) =>
                      `translate(${x((prev.get(d) || d).value)},${y(
                        (prev.get(d) || d).rank
                      )})`
                  )
                  .attr("y", y.bandwidth() / 2)
                  .attr("x", -6 + 125)
                  .attr("dy", "-0.25em")
                  .text((d) => d.name)
                  .call((text) =>
                    text
                      .append("tspan")
                      .attr("fill-opacity", 0.7)
                      .attr("font-weight", "normal")
                      .attr("x", -6 + 125)
                      .attr("dy", "1.15em")
                  ),
              (update) => update,
              (exit) =>
                exit
                  .transition(transition)
                  .remove()
                  .attr(
                    "transform",
                    (d) =>
                      `translate(${x((next.get(d) || d).value)},${y(
                        (next.get(d) || d).rank
                      )})`
                  )
                  .call((g) =>
                    g
                      .select("tspan")
                      .tween("text", (d) =>
                        textTween(d.value, (next.get(d) || d).value)
                      )
                  )
            )
            .call((bar) =>
              bar
                .transition(transition)
                .attr(
                  "transform",
                  (d) => `translate(${x(d.value)},${y(d.rank)})`
                )
                .call((g) =>
                  g
                    .select("tspan")
                    .tween("text", (d) =>
                      textTween((prev.get(d) || d).value, d.value)
                    )
                )
            ));
      }

      //texttween
      function textTween(a, b) {
        const i = d3.interpolateNumber(a, b);
        return function (t) {
          this.textContent = formatNumber(i(t));
        };
      }

      var formatNumber = d3.format(",d");

      //axis
      function axis(svg) {
        const g = svg
          .append("g")
          .attr("transform", `translate(0,${margin.top})`);

        const axis = d3
          .axisTop(x)
          .ticks(width / 160)
          .tickSizeOuter(0)
          .tickSizeInner(-barSize * (n + y.padding()));

        return (_, transition) => {
          g.transition(transition).call(axis);
          g.select(".tick:first-of-type text").remove();
          g.selectAll("text").attr("stroke", "rgba(255, 255, 255, 0.515)");
          g.selectAll(".tick:not(:first-of-type) line").attr(
            "stroke",
            "rgba(255, 255, 255, 0.15)"
          );
          g.select(".domain").remove();
        };
      }

      //ticker
      function ticker(svg) {
        const now = svg
          .append("text")
          //.style("font", `bold ${barSize}px var(--sans-serif)`)
          .style("font-variant-numeric", "tabular-nums")
          .attr("text-anchor", "end")
          .attr("font-size", 30)
          .attr("fill", "rgba(255, 255, 255, 0.815)")
          .attr("x", width - 6)
          .attr("y", margin.top + barSize * (n - 0.45))
          .attr("dy", "0.32em")
          .text(formatDate(keyframes[0][0]));

        return ([date], transition) => {
          transition.end().then(() => now.text(formatDate(date)));
        };
      }

      //color scale
      // function color() {
      //   const scale = d3.scaleOrdinal(d3.schemeTableau10);
      //   if (data.some((d) => d.category !== undefined)) {
      //     const categoryByName = new Map(data.map((d) => [d.name, d.category]));
      //     scale.domain(Array.from(categoryByName.values()));
      //     return (d) => scale(categoryByName.get(d.name));
      //   }
      //   return (d) => scale(d.name);
      // }

      //position
      var x = d3.scaleLinear([0, 1], [margin.left, width - margin.right]);
      var y = d3
        .scaleBand()
        .domain(d3.range(n + 1))
        .rangeRound([margin.top, margin.top + barSize * (n + 1 + 0.1)])
        .padding(0.1);

      const updateBars = bars(svg);
      const updateAxis = axis(svg);
      const updateLabels = labels(svg);
      const updateTicker = ticker(svg);

      async function draw() {
        for (const keyframe of keyframes) {
          const transition = svg
            .transition()
            .duration(duration)
            .ease(d3.easeLinear);

          // Extract the top bar’s value.
          x.domain([0, keyframe[1][0].value]);

          updateAxis(keyframe, transition);
          updateBars(keyframe, transition);
          updateLabels(keyframe, transition);
          updateTicker(keyframe, transition);

          // invalidation.then(() => svg.interrupt());
          await transition.end();
        }
      }

      draw();
    },
  },
  mounted: function () {
    console.log("mounted");

    if (!this.$store.state.bar_chart_race_data) {
      d3.json("bar_chart_race.json").then((data) => {
        this.bar_chart_race_data = data;
        // console.log("chartData set from file");
        // console.log("chartData contains", this.chartData.length, "rows");
        this.$store.commit("bar_chart_race_data", this.bar_chart_race_data);

        // this.barChart();

        this.first_draw();
      });
    } else {
      //console.log(this.$store.state.bar_chart_race_data)
      this.bar_chart_race_data = this.$store.state.bar_chart_race_data;
      //   console.log("chartData set from store");
      //console.log("chartData contains", this.bar_chart_race_data.length, "rows");
      //   this.barChart();

      this.first_draw();
    }
  },
};
</script>

<style scoped>

body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  background: #121212;
  min-height: 180vh;
  width: 100%;
}
.title {
  position: absolute;
  color: rgba(255, 255, 255, 0.781);
  font-size: 25px;
  top: 10%;
  left: 14.5%;
}
.logo {
  position: absolute;
  top: 9%;
  left: 10%;
}
.Intro {
  position: absolute;
  color: rgba(255, 255, 255, 0.93);
  padding: 10px;
  width: 80%;
  height: 20%;
  background: #272727;
  border-radius: 15px;
  top: 20%;
  left: 10%;
  text-align: left;
  overflow: hidden;
}
.Intro2 {
  position: absolute;
  color: rgba(255, 255, 255, 0.93);
  padding: 10px;
  width: 80%;
  height: 20%;
  background: #272727;
  border-radius: 15px;
  top: 45%;
  left: 10%;
  text-align: left;
  overflow: hidden;
}
.Intro-title {
  font-size: 25px;
  margin-left: 2%;
}
.Intro-explain {
  margin-top: 0.5%;
  margin-left: 2%;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.815);
}
.race {
  position: absolute;
  background: #272727;
  width: 80%;
  height: 650px;
  border-radius: 15px;
  top: 70%;
  left: 10%;
  overflow: hidden;
}
.race_title {
  padding: 10px;
  margin-left: 2%;
  color: rgba(255, 255, 255, 0.93);
  font-size: 25px;
}
.button {
  position: absolute;
  top: 2%;
  left: 55%;
}
.button2 {
  position: absolute;
  top: 2%;
  left: 66%;
}
.button3 {
  position: absolute;
  top: 2%;
  left: 77.5%;
}
.race_chart {
  position: absolute;
  left: 3%;
  top: 12%;
}
.next {
  position: absolute;
  left: 48%;
  top: 165%;
}
</style>